var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tonnage-summary"},[_c('h4',[_vm._v("Total producciones")]),_vm._v(" "),_c('div',{staticClass:"tonnage-display"},[_c('span',{staticClass:"tonnage-value"},[_vm._v(_vm._s(_vm.formattedKilograms)+" kgs")]),_vm._v(" "),_c('small',{staticClass:"tonnage-count"},[_vm._v("("+_vm._s(_vm.eventCount)+" eventos)")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }